







































import {
  Component,
  Vue,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useConsumerBankAccountStore } from "@/employee/store/consumerBankAccount";
import {
  FetchState,
  HsabSsoDestination
} from "@/shared/types";

@Component({
  computed: {
    FetchState () {
      return FetchState;
    },
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: { SsoDeepLink, GenericLoadingSpinner }
})
export default class HsabExpensePaymentDetails extends Vue {
  contactInformationStore = useContactInfoStore();
  consumerBankAccountStore = useConsumerBankAccountStore();

  mounted () {
    this.contactInformationStore.getContactInformation();
    this.consumerBankAccountStore.loadBankAccounts();
  }

  get hasLinkedBankAccount () {
    return this.consumerBankAccountStore.getDirectDepositAccount
        && this.consumerBankAccountStore.getDirectDepositAccount.bankAccountKey
        && !this.isStringNullOrEmpty(this.consumerBankAccountStore.getDirectDepositAccount.bankAccountKey.accountLastFour);
  }

  get bankAccountDisplay (): string {
    if (this.hasLinkedBankAccount) {
      return this.MaskBankAccountNumber(this.consumerBankAccountStore.getDirectDepositAccount.bankAccountKey.accountLastFour);
    }
    return "No linked bank account.";
  }

  MaskBankAccountNumber (acctLastFour): string {
    return "*****" + acctLastFour;
  }

  isStringNullOrEmpty (str) {
    return str === undefined || str === null || str === "";
  }
}
